import React from "react";
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { actions as userActions } from "../user/redux/model";
import Firebase from "../common/Firebase";
import { useHistory } from "react-router-dom";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import VideoLibraryOutlinedIcon from "@material-ui/icons/VideoLibraryOutlined";
import QueueOutlinedIcon from "@material-ui/icons/QueueOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useUserObj, useRelatedPrograms } from "../user/redux/hooks";
import { UserType } from "../server/serverTypes";
import { actions as navigationActions } from "../navigation/model";
const drawerWidth = 293;

const useStyles = makeStyles(() => ({
  root: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  container: {
    display: "flex",
    flex: 1,
  },
  main: {
    flex: 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#EBF0F2",
  },
  drawerContainer: {
    overflow: "auto",
  },
  username: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "24px",
  },
  sidebarText: {
    textDecorationLine: "underline",
  },
  listIcon: {
    minWidth: "44px",
    placeContent: "center",
    alignItems: "center",
  },
  accordionRoot: {
    boxShadow: "none",
    backgroundColor: "transparent",
  },
  accordionSummary: {
    padding: "0px",
  },
  listItem: {
    padding: "8px 0px",
  },
  menuBtn: {
    "&:hover": {
      backgroundColor: "rgba(39, 39, 39, 0.15)",
    },
  },
}));

const SideDrawer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const userInfo = useUserObj();
  const isMentor = userInfo?.user.type === UserType.mentor ? true : false;
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const programs = useRelatedPrograms();
  const navigateToPage = (route: string) => {
    // history.push(route);
    // console.log(route);
    // history.replace(route);
    // dispatch(navigationActions.toRoute(route));
  };

  if (!userInfo) {
    return <></>;
  }

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Toolbar style={{ minHeight: "118px" }} />

      <div className={classes.drawerContainer}>
        <div style={{ width: "100%", textAlign: "center", margin: "20px 0px" }}>
          <svg
            width="273"
            height="39"
            viewBox="0 0 273 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M196.318 20.0931C196.677 20.0931 197.002 20.1772 197.292 20.3452C197.583 20.5083 197.811 20.7407 197.976 21.0422C198.14 21.3436 198.223 21.6872 198.223 22.0728C198.223 22.4583 198.14 22.8019 197.976 23.1034C197.811 23.4048 197.583 23.6397 197.292 23.8077C197.002 23.9758 196.677 24.0598 196.318 24.0598C195.999 24.0598 195.711 23.9906 195.453 23.8522C195.202 23.7139 194.998 23.5137 194.843 23.2517V24.0228H194.349V18.5212H194.865V20.8642C195.025 20.6121 195.228 20.4219 195.475 20.2933C195.727 20.1598 196.009 20.0931 196.318 20.0931ZM196.282 23.5927C196.548 23.5927 196.791 23.5309 197.009 23.4074C197.227 23.2788 197.397 23.0985 197.518 22.8661C197.644 22.6337 197.707 22.3693 197.707 22.0728C197.707 21.7762 197.644 21.5118 197.518 21.2794C197.397 21.047 197.227 20.8691 197.009 20.7456C196.791 20.617 196.548 20.5528 196.282 20.5528C196.01 20.5528 195.766 20.617 195.548 20.7456C195.334 20.8691 195.166 21.047 195.039 21.2794C194.918 21.5118 194.857 21.7762 194.857 22.0728C194.857 22.3693 194.918 22.6337 195.039 22.8661C195.166 23.0985 195.334 23.2788 195.548 23.4074C195.766 23.5309 196.01 23.5927 196.282 23.5927ZM202.38 20.1228L200.469 24.4899C200.315 24.8557 200.134 25.1152 199.931 25.2684C199.727 25.4216 199.483 25.4982 199.197 25.4982C199.013 25.4982 198.84 25.4686 198.681 25.4093C198.521 25.3499 198.383 25.261 198.266 25.1423L198.506 24.7494C198.701 24.947 198.934 25.046 199.204 25.046C199.378 25.046 199.527 24.9966 199.647 24.8977C199.774 24.7988 199.89 24.6307 199.996 24.3935L200.163 24.0153L198.455 20.1228H198.993L200.432 23.437L201.871 20.1228H202.38Z"
              fill="black"
            />
            <path
              d="M39.0457 31.4374L34.1905 24.4975C33.4734 24.5964 32.8143 24.6458 32.2135 24.6458H26.3988V31.4374H24.916V10.677H32.2135C34.7719 10.677 36.778 11.2998 38.2317 12.5454C39.6853 13.7713 40.4122 15.4815 40.4122 17.6762C40.4122 19.3173 39.9954 20.7013 39.162 21.8283C38.348 22.9356 37.1753 23.7165 35.6441 24.1713L40.732 31.4374H39.0457ZM32.2135 23.3112C34.3842 23.3112 36.0414 22.8267 37.185 21.858C38.3286 20.8693 38.9004 19.4754 38.9004 17.6762C38.9004 15.877 38.3286 14.4929 37.185 13.5241C36.0414 12.5355 34.3842 12.0412 32.2135 12.0412H26.3988V23.3112H32.2135ZM45.3757 15.9561H46.8294V31.4374H45.3757V15.9561ZM46.1026 12.1895C45.7732 12.1895 45.492 12.0808 45.2595 11.8633C45.0269 11.626 44.9106 11.3393 44.9106 11.0032C44.9106 10.6671 45.0269 10.3804 45.2595 10.1431C45.492 9.90586 45.7732 9.78723 46.1026 9.78723C46.4321 9.78723 46.7131 9.90586 46.9457 10.1431C47.1783 10.3606 47.2946 10.6374 47.2946 10.9735C47.2946 11.3097 47.1783 11.5964 46.9457 11.8336C46.7131 12.0709 46.4321 12.1895 46.1026 12.1895ZM56.7942 31.556C55.5731 31.556 54.4102 31.3682 53.3054 30.9926C52.2006 30.6169 51.338 30.1424 50.7179 29.569L51.3865 28.3827C52.0067 28.9165 52.8014 29.3614 53.7706 29.7173C54.7591 30.0732 55.7862 30.2511 56.8524 30.2511C58.3835 30.2511 59.5076 29.9941 60.2249 29.48C60.9613 28.9659 61.3297 28.2541 61.3297 27.3446C61.3297 26.6922 61.1262 26.1781 60.7191 25.8024C60.3314 25.4268 59.8469 25.15 59.2655 24.972C58.684 24.7941 57.8795 24.6062 56.8524 24.4085C55.6506 24.191 54.6814 23.9537 53.945 23.6967C53.2084 23.4398 52.5786 23.0245 52.0552 22.4511C51.5319 21.8777 51.2703 21.0868 51.2703 20.0785C51.2703 18.8526 51.7645 17.8442 52.753 17.0534C53.7608 16.2427 55.1854 15.8374 57.0268 15.8374C57.9958 15.8374 58.9552 15.9758 59.9051 16.2526C60.8548 16.5295 61.63 16.8952 62.231 17.35L61.5623 18.5363C60.942 18.0815 60.2345 17.7355 59.4399 17.4983C58.6452 17.261 57.8311 17.1424 56.9977 17.1424C55.5827 17.1424 54.5167 17.4093 53.7996 17.9431C53.0824 18.477 52.7239 19.1788 52.7239 20.0488C52.7239 20.7409 52.9274 21.2845 53.3345 21.68C53.7415 22.0556 54.2357 22.3424 54.8172 22.5401C55.418 22.718 56.2514 22.9157 57.3175 23.1332C58.4998 23.3508 59.4495 23.588 60.1667 23.845C60.9032 24.0823 61.5235 24.4778 62.0274 25.0313C62.5313 25.5849 62.7834 26.3462 62.7834 27.315C62.7834 28.6002 62.26 29.6283 61.2134 30.3994C60.1667 31.1705 58.6936 31.556 56.7942 31.556ZM66.8403 15.9561H68.2939V31.4374H66.8403V15.9561ZM67.5671 12.1895C67.2376 12.1895 66.9566 12.0808 66.724 11.8633C66.4914 11.626 66.3751 11.3393 66.3751 11.0032C66.3751 10.6671 66.4914 10.3804 66.724 10.1431C66.9566 9.90586 67.2376 9.78723 67.5671 9.78723C67.8965 9.78723 68.1776 9.90586 68.4102 10.1431C68.6428 10.3606 68.7591 10.6374 68.7591 10.9735C68.7591 11.3097 68.6428 11.5964 68.4102 11.8336C68.1776 12.0709 67.8965 12.1895 67.5671 12.1895ZM81.8346 15.8374C83.7341 15.8374 85.2362 16.4009 86.341 17.5279C87.4458 18.6549 87.9982 20.2762 87.9982 22.3918V31.4374H86.5445V22.5104C86.5445 20.7705 86.1084 19.4457 85.2362 18.5363C84.3833 17.6268 83.1817 17.172 81.6311 17.172C79.8479 17.172 78.4428 17.7158 77.4155 18.8032C76.3881 19.8906 75.8746 21.3538 75.8746 23.1926V31.4374H74.4209V15.9561H75.8164V19.3074C76.3397 18.22 77.115 17.3697 78.1423 16.7568C79.1889 16.1439 80.4198 15.8374 81.8346 15.8374ZM107.676 15.9561V29.7766C107.676 32.3469 107.065 34.245 105.844 35.4709C104.623 36.6968 102.782 37.3097 100.32 37.3097C98.9249 37.3097 97.6068 37.0921 96.3664 36.6572C95.1259 36.2223 94.1278 35.6192 93.3718 34.8481L94.1568 33.7211C94.9127 34.4329 95.8236 34.9864 96.8897 35.3819C97.9557 35.7774 99.0896 35.9751 100.291 35.9751C102.307 35.9751 103.799 35.4808 104.769 34.4922C105.738 33.5234 106.222 32.0109 106.222 29.9545V27.3446C105.602 28.4716 104.74 29.3417 103.635 29.9545C102.53 30.5674 101.289 30.8739 99.9134 30.8739C98.4984 30.8739 97.2095 30.5576 96.0466 29.9249C94.903 29.2724 94.0017 28.3727 93.3428 27.226C92.6837 26.0793 92.3543 24.7841 92.3543 23.3408C92.3543 21.8975 92.6837 20.6024 93.3428 19.4557C94.0017 18.309 94.903 17.4192 96.0466 16.7865C97.2095 16.1537 98.4984 15.8374 99.9134 15.8374C101.309 15.8374 102.569 16.1537 103.693 16.7865C104.817 17.4192 105.68 18.309 106.28 19.4557V15.9561H107.676ZM100.03 29.5393C101.212 29.5393 102.278 29.2823 103.228 28.7682C104.177 28.2344 104.914 27.5029 105.437 26.5735C105.98 25.6245 106.251 24.5469 106.251 23.3408C106.251 22.1348 105.98 21.0671 105.437 20.1378C104.914 19.2085 104.177 18.4869 103.228 17.9728C102.278 17.4389 101.212 17.172 100.03 17.172C98.8473 17.172 97.7813 17.4389 96.8316 17.9728C95.9012 18.4869 95.1647 19.2085 94.622 20.1378C94.0987 21.0671 93.837 22.1348 93.837 23.3408C93.837 24.5469 94.0987 25.6245 94.622 26.5735C95.1647 27.5029 95.9012 28.2344 96.8316 28.7682C97.7813 29.2823 98.8473 29.5393 100.03 29.5393ZM119.847 31.7933C118.239 31.7933 116.678 31.5758 115.166 31.1408C113.674 30.686 112.472 30.1028 111.561 29.391L113.16 25.7728C114.033 26.4253 115.07 26.9492 116.271 27.3446C117.473 27.7401 118.675 27.9378 119.876 27.9378C121.214 27.9378 122.202 27.7401 122.842 27.3446C123.482 26.9294 123.801 26.3857 123.801 25.7135C123.801 25.2192 123.607 24.8138 123.22 24.4975C122.851 24.1613 122.367 23.8944 121.766 23.6967C121.185 23.4991 120.39 23.2815 119.382 23.0443C117.832 22.6686 116.562 22.2929 115.574 21.9173C114.585 21.5417 113.732 20.9386 113.015 20.1081C112.317 19.2777 111.968 18.1705 111.968 16.7865C111.968 15.5804 112.288 14.4929 112.928 13.5241C113.567 12.5355 114.527 11.7545 115.806 11.1811C117.105 10.6078 118.684 10.3211 120.545 10.3211C121.844 10.3211 123.113 10.4793 124.354 10.7956C125.594 11.1119 126.68 11.5667 127.61 12.1599L126.156 15.8078C124.276 14.7203 122.396 14.1766 120.516 14.1766C119.198 14.1766 118.219 14.3941 117.58 14.8291C116.959 15.264 116.649 15.8374 116.649 16.5492C116.649 17.261 117.008 17.7948 117.725 18.1507C118.461 18.4869 119.576 18.8229 121.068 19.1591C122.619 19.5347 123.889 19.9105 124.877 20.2861C125.866 20.6617 126.709 21.2549 127.406 22.0656C128.124 22.8763 128.482 23.9736 128.482 25.3576C128.482 26.5439 128.153 27.6313 127.494 28.6199C126.854 29.5887 125.885 30.3598 124.586 30.9332C123.288 31.5067 121.708 31.7933 119.847 31.7933ZM135.632 14.5918H129.12V10.677H146.855V14.5918H140.342V31.4374H135.632V14.5918ZM161.769 26.9888H152.32L150.518 31.4374H145.692L154.763 10.677H159.414L168.514 31.4374H163.572L161.769 26.9888ZM160.286 23.3408L157.059 15.3926L153.832 23.3408H160.286ZM183.593 31.4374L179.668 25.6541H179.436H175.336V31.4374H170.626V10.677H179.436C181.238 10.677 182.798 10.9834 184.117 11.5964C185.454 12.2093 186.48 13.0792 187.198 14.2062C187.915 15.3332 188.274 16.6678 188.274 18.21C188.274 19.7522 187.905 21.0869 187.169 22.2138C186.451 23.3211 185.425 24.1713 184.087 24.7644L188.652 31.4374H183.593ZM183.506 18.21C183.506 17.0435 183.137 16.1537 182.401 15.5408C181.664 14.9081 180.589 14.5918 179.174 14.5918H175.336V21.8283H179.174C180.589 21.8283 181.664 21.512 182.401 20.8792C183.137 20.2465 183.506 19.3568 183.506 18.21Z"
              fill="#272727"
            />
            <path
              d="M8.83137 27.1341C8.83137 29.5365 4.27882 32.354 1.67329 30.614C0.0178455 28.8741 0.140213 29.5365 0.140213 27.1341C0.140213 24.7317 1.99313 22.7841 4.27882 22.7841C6.5645 22.7841 8.83137 24.7317 8.83137 27.1341Z"
              fill="white"
            />
            <path
              d="M16.6975 14.4147H3.45068V26.9692H16.6975V14.4147Z"
              fill="white"
            />
            <path
              d="M0.459463 26.6301L6.73742 20.9704L5.06033 20.0586C4.29414 19.6416 4.50883 18.5687 5.37867 18.426L7.59603 18.0661C7.9739 18.005 8.28272 17.7371 8.36982 17.3914L8.86417 15.3636C9.0555 14.5571 10.2322 14.4195 10.6506 15.1472L11.7109 16.9764C11.8948 17.2943 12.2599 17.4699 12.6487 17.445L14.892 17.2458C15.7764 17.1623 16.2928 18.1493 15.6683 18.7377L14.1038 20.2353C13.8341 20.493 13.7579 20.8749 13.9134 21.2062L14.8064 23.1051C15.1572 23.8562 14.3053 24.6168 13.5074 24.256L12.2982 23.7155L4.03591 31.1642C8.28426 33.0717 15.5244 29.9866 19.0558 24.3512C21.7259 20.0901 20.1359 14.6226 15.511 12.1625C10.8862 9.70233 4.95203 11.1674 2.28192 15.4284C0.0140147 19.0475 -0.500331 23.3614 0.459463 26.6301Z"
              fill="#4DC591"
            />
            <path
              d="M1.87561 30.7432L9.35816 23.8491L7.86682 22.475L0.384277 29.3691L1.87561 30.7432Z"
              fill="#4DC591"
            />
            <path
              d="M207.439 26.5836V17.532H210.581C211.707 17.532 212.562 17.7454 213.147 18.1723C213.735 18.5993 214.03 19.2188 214.03 20.0311C214.03 20.4994 213.926 20.8994 213.718 21.231C213.509 21.5625 213.203 21.8071 212.798 21.9645C213.254 22.0888 213.604 22.321 213.85 22.6608C214.094 23.0006 214.216 23.4151 214.216 23.9042C214.216 24.7911 213.943 25.4584 213.4 25.9059C212.859 26.3494 212.055 26.5753 210.989 26.5836H207.439ZM209.549 22.7355V24.9051H210.93C211.311 24.9051 211.603 24.816 211.806 24.6377C212.011 24.4553 212.113 24.2004 212.113 23.873C212.113 23.1188 211.751 22.7395 211.026 22.7355H209.549ZM209.549 21.3055H210.648C211.109 21.3014 211.437 21.2143 211.633 21.0444C211.83 20.8745 211.927 20.6237 211.927 20.2923C211.927 19.9109 211.821 19.6374 211.609 19.4717C211.396 19.3017 211.053 19.2167 210.581 19.2167H209.549V21.3055ZM217.425 26.5836H215.394V17.0347H217.425V26.5836ZM222.338 26.5836C222.265 26.4469 222.202 26.2458 222.146 25.9805C221.774 26.4654 221.252 26.7079 220.584 26.7079C219.972 26.7079 219.451 26.5173 219.022 26.1361C218.594 25.7505 218.38 25.2677 218.38 24.6874C218.38 23.958 218.64 23.4068 219.16 23.0338C219.681 22.6608 220.438 22.4744 221.431 22.4744H222.056V22.1199C222.056 21.5025 221.797 21.1937 221.281 21.1937C220.8 21.1937 220.56 21.4381 220.56 21.9272H218.535C218.535 21.2765 218.801 20.7481 219.335 20.342C219.871 19.9358 220.555 19.7328 221.383 19.7328C222.212 19.7328 222.867 19.942 223.347 20.3606C223.828 20.7793 224.074 21.3533 224.087 22.0827V25.0605C224.094 25.678 224.187 26.1504 224.363 26.4779V26.5836H222.338ZM221.071 25.2159C221.324 25.2159 221.531 25.1599 221.696 25.0481C221.864 24.9361 221.983 24.8098 222.056 24.6689V23.5933H221.467C220.762 23.5933 220.409 23.9208 220.409 24.5756C220.409 24.7662 220.472 24.9216 220.597 25.0418C220.72 25.1578 220.879 25.2159 221.071 25.2159ZM227.961 25.0915C228.246 25.0915 228.465 25.0128 228.622 24.8553C228.778 24.6936 228.855 24.4699 228.851 24.1838H230.749C230.749 24.9216 230.492 25.5267 229.98 25.9992C229.471 26.4716 228.814 26.7079 228.009 26.7079C227.064 26.7079 226.32 26.4012 225.775 25.7879C225.23 25.1744 224.958 24.3249 224.958 23.2389V23.1519C224.958 22.4723 225.077 21.8733 225.318 21.3552C225.562 20.8331 225.913 20.4332 226.369 20.1554C226.826 19.8737 227.366 19.7328 227.992 19.7328C228.836 19.7328 229.508 19.9752 230.003 20.4601C230.501 20.9451 230.749 21.602 230.749 22.4308H228.851C228.851 22.0827 228.768 21.8154 228.604 21.6288C228.439 21.4424 228.22 21.3491 227.944 21.3491C227.419 21.3491 227.112 21.6951 227.023 22.3873C226.996 22.6069 226.983 22.9094 226.983 23.295C226.983 23.9704 227.06 24.4387 227.217 24.6999C227.372 24.961 227.621 25.0915 227.961 25.0915ZM234.215 24.0782L233.645 24.6689V26.5836H231.62V17.0284H233.645V22.1013L233.848 21.8216L235.375 19.8571H237.801L235.524 22.6235L237.952 26.5836H235.633L234.215 24.0782ZM239.429 17.532L243.028 26.0925L246.639 17.532H247.113V26.5836H246.789V18.0294L243.161 26.5836H242.902L239.291 18.0728V26.5836H238.967V17.532H239.429ZM249.859 26.5836H249.535V19.341H249.859V26.5836ZM257.542 26.5836H257.218L252.423 19.9007V26.5836H252.099V19.341H252.423L257.218 26.0054V19.341H257.542V26.5836ZM265.587 17.8678H262.403V26.5836H262.079V17.8678H258.894V17.532H265.587V17.8678Z"
              fill="black"
            />
          </svg>
        </div>
        <List
          style={{
            padding: "12px",
            backgroundColor: "rgba(39, 39, 39, 0.1)",
          }}
        >
          <ListItem style={{ padding: 0 }}>
            <Typography component="h2" className={classes.username}>
              {userInfo.user.name}
            </Typography>
          </ListItem>
          <ListItem style={{ padding: 0 }}>
            <div
              onClick={() => {
                dispatch(userActions.signOut());
                Firebase.auth.signOut();
              }}
              className={classes.sidebarText}
              style={{ textDecorationLine: "underline", cursor: "pointer" }}
            >
              Sign Out
            </div>
          </ListItem>
        </List>
        <List>
          <ListItem
            button
            onClick={() => {
              //   navigateToPage(ROUTES.home);
              history.push("/");
            }}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listIcon}>
              <HomeOutlinedIcon style={{ color: "black" }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.sidebarText}>Home</Typography>
              }
            />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              //   navigateToPage(ROUTES.home);
            }}
            className={classes.listItem}
          >
            <Accordion
              expanded={expanded}
              onChange={() => {
                setExpanded(!expanded);
              }}
              classes={{ root: classes.accordionRoot }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                classes={{ root: classes.accordionSummary }}
              >
                <ListItemIcon className={classes.listIcon}>
                  <PersonOutlineOutlinedIcon style={{ color: "black" }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography className={classes.sidebarText}>
                      {isMentor ? "Mentees" : "Mentors"}
                    </Typography>
                  }
                />
              </AccordionSummary>
              <AccordionDetails style={{ paddingLeft: "44px" }}>
                <Grid container>
                  {isMentor
                    ? programs.map((m) => (
                        <Grid
                          item
                          xs={12}
                          onClick={() =>
                            navigateToPage("mentor/" + m.firebaseHash)
                          }
                          style={
                            {
                              // border: "solid black",
                            }
                          }
                          className={classes.menuBtn}
                        >
                          <Typography>{m.name}</Typography>
                        </Grid>
                      ))
                    : programs.map((m) => (
                        <Grid
                          item
                          xs={12}
                          onClick={() =>
                            navigateToPage("mentee/" + m.firebaseHash)
                          }
                          style={
                            {
                              // border: "solid black",
                            }
                          }
                          className={classes.menuBtn}
                        >
                          <Typography>{m.name}</Typography>
                        </Grid>
                      ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </ListItem>
          {/* <ListItem
            button
            onClick={() => {
              history.push("/videos");
            }}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listIcon}>
              <VideoLibraryOutlinedIcon style={{ color: "black" }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.sidebarText}>Videos</Typography>
              }
            />
          </ListItem> */}
          {userInfo.user.type === UserType.admin ? (
            <ListItem
              button
              onClick={() => {
                history.push("/add-video");
              }}
              className={classes.listItem}
            >
              <ListItemIcon className={classes.listIcon}>
                <QueueOutlinedIcon style={{ color: "black" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography className={classes.sidebarText}>
                    Add Video
                  </Typography>
                }
              />
            </ListItem>
          ) : null}
        </List>
      </div>
    </Drawer>
  );
};

export default SideDrawer;
